export const { PaymentRequest } = typeof window === 'undefined' ? { PaymentRequest: null } : window;
//# sourceMappingURL=payment-request.web.js.map